import { createSlice, createSelector } from '@reduxjs/toolkit';
export const pageDataInitialState = {};
const pageDataSlice = createSlice({
    name: 'pageData',
    initialState: pageDataInitialState,
    reducers: {
        setPageMetaData: (state, action) => action.payload,
    },
});
export const pageDataSelector = (state) => state.pageData || {};
export const momentShownPayloadSelector = createSelector([pageDataSelector], (pageData) => ({
    moment_name: pageData.name,
    moment_id: pageData.id,
    codename: pageData.codename,
}));
export const { setPageMetaData } = pageDataSlice.actions;
export default pageDataSlice.reducer;
//# sourceMappingURL=pageData.js.map